var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveSnackbar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12,
    cy: 12,
    r: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.46191,
    y: 9,
    width: 7.83269,
    height: 0.652724,
    rx: 0.326362,
    transform: "rotate(45 9.46191 9)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14.5386,
    width: 7.83269,
    height: 0.652724,
    rx: 0.326362,
    transform: "rotate(-45 9 14.5386)",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSnackbar);
export default __webpack_public_path__ + "static/media/remove-snackbar.05eeb767ed76b33e43513dd5e726a1f2.svg";
export { ForwardRef as ReactComponent };